import React, { useState, useEffect } from 'react';
import { RolesActions } from '@wajeez-web/stores/roles';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Identity } from '@wajeez-web/core/api-base';
import { InputLabel, CheckBox } from '@wajeez-web/components/ui';

function onlyUnique(value: string, index: number, self: string) {
  return self.indexOf(value) === index;
}

export interface RoleClaimsProps {
  roleId: string;
  roleName: string;
  roleClaims: {
    group?: string;
    roles?: Identity.RoleClaimOutput[];
  }[];
}
const RoleClaimsModal: React.FC<
  CommonModalProps<Identity.RolePermissionOutput>
> = ({ isOpen, onClose, onSubmit, data }) => {
  const [roleClaimes, setRoleClaimes] = useState<RoleClaimsProps>({
    roleClaims: [],
    roleId: '',
    roleName: '',
  });

  useEffect(() => {
    if (data) {
      const newRoleClaimes = data.roleClaims
        ?.map((item) => item.group)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .filter(onlyUnique)
        .map((item) => {
          return {
            group: item,
            roles: data.roleClaims?.filter((ele) => item === ele.group),
          };
        });

      setRoleClaimes({
        roleId: data.roleId || '',
        roleName: data.roleName || '',
        roleClaims: newRoleClaimes || [],
      });
    }
  }, [data]);

  const updateOnroleClaims = (i: number, val: boolean, index: number) => {
    const newRoleClame = {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ...roleClaimes.roleClaims[index]?.roles[i],
      selected: val,
    };
    const d = roleClaimes.roleClaims;
    const x = d[index];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    x.roles[i] = newRoleClame;

    setRoleClaimes({ ...roleClaimes, roleClaims: d });
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Assign permissions to role"
      withScroll={true}
      onSubmit={async () => {
        const roleclaim: any[] = [];
        await roleClaimes.roleClaims.forEach((item: any) => {
          item.roles.forEach((element: any) => roleclaim.push({ ...element }));
        });

        onSubmit &&
          onSubmit({
            roleId: roleClaimes.roleId,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            roleClaims: roleclaim,
          });
      }}
    >
      <div className=" space-y-10  ">
        <div className={`grid grid-cols-${2} gap-3  `}>
          {roleClaimes &&
            roleClaimes?.roleClaims?.map((item, index: number) => (
              <div className={`md:col-span-${1} col-span-${2}`}>
                <InputLabel text={item.group} name="" />

                {item?.roles?.map((item, i: number) => (
                  <CheckBox
                    name="selected"
                    checked={item.selected}
                    label={item.description}
                    onClick={(checked) =>
                      updateOnroleClaims(i, checked || false, index)
                    }
                  />
                ))}
              </div>
            ))}
        </div>
      </div>
    </Modal>
  );
};

export default RoleClaimsModal;
